/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { ColumnInstance } from 'react-table';
import { css, StyleSheet } from 'aphrodite';
import { BrandColors, Text } from '@blend/enterprise-components';
import { NotaryAPI } from '../../../api/notary/types';
import { toUpper } from '@utils/lodash';

export namespace TableHeader {
  export interface OwnProps {}
  export interface ColumnProps {
    column: ColumnInstance<NotaryAPI.RoomListItem>;
  }
  export type Props = OwnProps & ColumnProps;
}

const styles = StyleSheet.create({
  tableHeaderContainer: {
    alignItems: 'center',
    display: 'flex',
  },
});

export const TableHeader: React.FC<TableHeader.Props> = ({ column }) => {
  return (
    <div className={css(styles.tableHeaderContainer)}>
      <Text color={BrandColors.NIGHT} fontSize="sm" weight="semibold">
        {toUpper(column.id)}
      </Text>
    </div>
  );
};
